var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.125 7.97461C12.0129 19.9372 14.2755 17.7025 7.97547 23.9248","stroke":"#1E2A67","strokeWidth":"6.0956","key":0}),React.createElement("path",{"d":"M7.97461 7.97461C20.049 19.9 17.8437 17.7219 24.1241 23.9248","stroke":"#1E2A67","strokeWidth":"6.0956","key":1})]);
}

CloseIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
